import Temp from '@/courier/Temp'

export default class SPRESS extends Temp {

    static CODE = 'EMSXP';

    constructor() {
        super( SPRESS.CODE );
    }

    getZone( item ){
        let type , to
        let cross_price = 0
        let remote_area = 0
        let prefixToPostCode = item.toPostcode.toString().substring( 0 , 2 )
        
        to = super.checkZone( prefixToPostCode );
        
        if (to == 1) {
          type = 1
        } else {
          type = 2
        }
        
        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates , item , validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })
        
        return super.checkRules( item , validate );
    }
    async checkRemoteAreaByCorrectorDest(addressRemote, option) {
        return new Promise((resolve) => {
          super.getArea([addressRemote], ["EMSXP"], option).then((res) => {
            let weight = option.weight;
            let returnRate = {
              isRemote: 0,
              isTravelArea: 0,
              isIsland: res.data.EMSXP.is_island ? 15 : 0
            };        
            resolve(returnRate);
          });
        });
      }
}